import React, { useState } from "react";
import { makeStyles } from "@mui/styles";
import {
  Button,
  Card,
  CardContent,
  Divider,
  FormHelperText,
  Grid,
  IconButton,
  TextField,
  Tooltip,
} from "@mui/material";
import { callAPI } from "../../../App/Helpers/callApi";
import LoadingBar from "../../../App/Components/LoadingBar/LoadingBar";
import { Delete, LocationOn } from "@mui/icons-material";
import { basicSort } from "../../../App/Helpers/BasicSort";
import { getCustomRadius, editCustomRadius } from "../CustomRadiusService";

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
    justifyContent: "space-between",
    width: "100%",
    display: "flex",
    flexDirection: "column",
  },

  error: {
    color: theme.palette.error.main,
  },
  card: {
    display: "flex",
    alignItems: "center",
    padding: "8px",
  },
  icon: {
    fontSize: "35px",
  },
  divider: {
    background: theme.palette.primary.main,
  },
  text: {
    paddingLeft: "10px",
    whiteSpace: "nowrap",
    color: theme.palette.primary.copy,
  },
}));
export default function EditCollectionModal({
  openModal,
  baseClient,
  setShowSignifier,
  setResponseMessage,
  setShowError,
  setTableData,
  tableData,
}) {
  const classes = useStyles();
  const [processing, setProcessing] = useState(false);
  const [inputError, setInputError] = useState(false);

  const [newRadius, setNewRadius] = useState("");
  const [tempData, setTempData] = useState([...tableData]);

  function editRadius() {
    callAPI(
      editCustomRadius(baseClient.id, tempData),
      "Radius Collection Updated",
      setShowSignifier,
      setResponseMessage,
      setShowError,
      setProcessing
    ).then(() => {
      getCustomRadius(baseClient.id).then((response) => {
        setTableData(response);
        openModal(false);
      });
    });
  }

  const addRadius = () => {
    if (newRadius === "") {
      setInputError(true);
      return;
    }
    var copy = [...tempData];
    var addRadius = { clientId: baseClient.id, value: newRadius };
    copy.push(addRadius);
    copy.sort((a, b) => {
      const order = basicSort(a.value, b.value);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    setTempData(copy);
    setNewRadius("");
  };

  const removeRadius = (index) => {
    var copy = [...tempData];
    copy.splice(index, 1);
    setTempData(copy);
  };

  return (
    <div className={classes.root}>
      <LoadingBar loading={processing} />
      <Grid>
        <Card>
          <CardContent>
            <FormHelperText style={{ fontWeight: "bold" }}>
              Edit Custom Radius Collection
            </FormHelperText>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={9}>
                <TextField
                  placeholder="Add Radius"
                  label="Add Radius"
                  variant="standard"
                  fullWidth
                  required
                  type="number"
                  error={inputError && newRadius === ""}
                  value={newRadius}
                  onChange={(e) => setNewRadius(parseInt(e.target.value))}
                />
                {inputError && (
                  <FormHelperText className={classes.error}>
                    Radius Required
                  </FormHelperText>
                )}
              </Grid>
              <Grid item xs={6} sm={3}>
                <Button
                  style={{ marginTop: "10px" }}
                  type="submit"
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={() => addRadius()}
                >
                  Add
                </Button>
              </Grid>
              {tempData.map((item, index) => (
                <div
                  hover
                  key={index}
                  style={{
                    width: "100%",
                    background: index % 2 ? "rgba(0,0,0,.08)" : "white",
                    padding: "10px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Grid item xs={12} sm={11}>
                    <div className={classes.card}>
                      <LocationOn className={classes.icon} color="primary" />
                      <Divider
                        orientation="vertical"
                        flexItem
                        className={classes.divider}
                      />
                      <span className={classes.text}>
                        <strong>{item.value}</strong> Miles
                      </span>
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={1}>
                    <Tooltip title="Delete Featured Event">
                      <IconButton
                        onClick={() => removeRadius(index)}
                        size="large"
                      >
                        <Delete />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                </div>
              ))}
              <Grid
                container
                justifyContent="flex-end"
                direction="row"
                style={{ marginRight: "10px" }}
              >
                <Grid item xs={6} sm={3}>
                  <Button
                    style={{ color: "#82B288", marginTop: "20px" }}
                    type="submit"
                    variant="outlined"
                    fullWidth
                    onClick={() => openModal(false)}
                  >
                    Cancel
                  </Button>
                </Grid>
                <Grid item xs={6} sm={3}>
                  <Button
                    style={{ marginTop: "20px", marginLeft: "10px" }}
                    type="submit"
                    variant="contained"
                    color="primary"
                    fullWidth
                    onClick={() => editRadius()}
                  >
                    Save
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </div>
  );
}
